module.exports = __webpack_public_path__ + "static/media/prepTimeImage.9cebcc19.svg";